import React from "react";
import {
  About,
  Contact,
  Features,
  Hero,
  Partners,
  Product,
  Roadmap,
  Token,
} from "./components";

const App = () => {
  return (
    <div className="app">
      <Hero />
      <About />
      <Product />
      <Token />
      <Features />
      <Roadmap />
      <Partners />
      <Contact />
    </div>
  );
};

export default App;
